"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var material_1 = require("@mui/material");
var button_1 = __importDefault(require("../button"));
var CustomDialog = function (_a) {
    var open = _a.open, _b = _a.title, title = _b === void 0 ? "Confirmation" : _b, message = _a.message, onConfirm = _a.onConfirm, onCancel = _a.onCancel, currentTheme = _a.currentTheme, themeMode = _a.themeMode;
    var fontColor = themeMode === "dark" ? "#fff" : "#000";
    return (react_1.default.createElement(material_1.Dialog, { open: open, onClose: onCancel, "aria-labelledby": "custom-popup-title", "aria-describedby": "custom-popup-description", PaperProps: {
            style: {
                backgroundColor: currentTheme.settingPage.popupBackground,
                borderRadius: "8px",
            },
        } },
        react_1.default.createElement(material_1.DialogTitle, { id: "custom-popup-title", style: { color: fontColor } }, title),
        react_1.default.createElement(material_1.DialogContent, null,
            react_1.default.createElement(material_1.DialogContentText, { id: "custom-popup-description", style: { color: fontColor } }, message)),
        react_1.default.createElement(material_1.DialogActions, null,
            react_1.default.createElement(button_1.default, { label: "Cancel", onClick: onCancel, backgroundColor: "#ff4e3a", width: "5rem", height: "2rem" }),
            react_1.default.createElement(button_1.default, { label: "Confirm", onClick: onConfirm, backgroundColor: "#ff4e3a", width: "5rem", height: "2rem" }))));
};
exports.default = CustomDialog;
